import dayjs from "dayjs";
import React, { createContext, useContext, useState } from "react";
import { View } from "react-big-calendar";

type CalendarContextType = {
    view: View;
    setView: (v: View) => void;
    date: Date;
    setDate: (d: Date) => void;
    dateRange: { start: Date, end: Date };
    setDateRange: (range: Date[] | { start: Date; end: Date }) => void;
    talentFilter: string[];
    setTalentFilter: (filter: string[]) => void;
    venueFilter: string[];
    setVenueFilter: (filter: string[]) => void;
    areaFilter: string[];
    setAreaFilter: (filter: string[]) => void;
};

const CalendarContext = createContext<CalendarContextType | undefined>(undefined);

const defaultStartDate = dayjs().startOf('month').subtract(7, 'day').toDate()
const defaultEndDate = dayjs().endOf('month').add(7, 'day').toDate()

export const CalendarProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [view, setView] = useState<View>("month");
    const [date, setDate] = useState<Date>(new Date());
    const [dateRange, handleRangeChange] = React.useState<{ start: Date, end: Date }>({ start: defaultStartDate, end: defaultEndDate })
    const [talentFilter, setTalentFilter] = React.useState<string[]>([]);
    const [venueFilter, setVenueFilter] = React.useState<string[]>([]);
    const [areaFilter, setAreaFilter] = React.useState<string[]>([]);

    const setDateRange = (range: Date[] | { start: Date; end: Date }) => {
        let start: Date;
        let end: Date;
        if (Array.isArray(range)) {
            start = range[0];
            end = range[range.length - 1];
        } else {
            start = range.start;
            end = range.end;
        }
        handleRangeChange({ start, end });
    };

    const value = {
        view, 
        setView, 
        date, 
        setDate,
        dateRange,  
        setDateRange,
        talentFilter,
        setTalentFilter,
        venueFilter,
        setVenueFilter,    
        areaFilter,
        setAreaFilter,
    };

    return <CalendarContext.Provider value={value}>{children}</CalendarContext.Provider>;
};

export const useCalendar = () => {
    const ctx = useContext(CalendarContext);
    if (!ctx) throw new Error("useCalendar must be used within a CalendarProvider");
    return ctx;
};